import { Hops, KeyIngredients, Malts, Yeasts } from '.'
import { Ingredient, IngredientType } from 'src/types/schema/graphql'

import React from 'react'
import classNames from 'classnames'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'

const Ingredients: React.FC = () => {
    const { ingredients, productData } = useBrewDetailStore()

    const keyIngredients = productData?.ingredients?.filter(
        (item) => item?.type?.toString() === 'KeyIngredients'
    )

    // Create an array for each ingredient type style
    const styleYeasts: Ingredient[] = productData?.style?.yeast
        ? [{ title: productData?.style?.yeast?.toString(), type: IngredientType.Yeasts }]
        : []
    const styleMalts: Ingredient[] = productData?.style?.malt
        ? [{ title: productData?.style?.malt?.toString(), type: IngredientType.Malts }]
        : []
    const styleHops: Ingredient[] = productData?.style?.hops
        ? [{ title: productData?.style?.hops?.toString(), type: IngredientType.Hops }]
        : []

    // Create array of brewer input ingredients
    const brewerYeasts = ingredients?.filter((val) => val?.type?.toString() === 'Yeasts')
    const brewerMalts = ingredients?.filter((val) => val?.type?.toString() === 'Malts')
    const brewerHops = ingredients?.filter((val) => val?.type?.toString() === 'Hops')

    // Check to see if there are either brewer input ingredients or style ingredients of the same type
    const anyYeasts =
        brewerYeasts?.length && productData?.__typename === 'Beer'
            ? brewerYeasts
            : styleYeasts?.length
            ? styleYeasts
            : null
    const anyMalts =
        brewerMalts?.length && productData?.__typename === 'Beer'
            ? brewerMalts
            : styleMalts?.length
            ? styleMalts
            : null
    const anyHops =
        brewerHops?.length && productData?.__typename === 'Beer'
            ? brewerHops
            : styleHops?.length
            ? styleHops
            : null
    const anyKeyIngredients =
        keyIngredients?.length && productData?.__typename !== 'Beer' ? keyIngredients : null

    // Get the number of ingredient categories to render grid columns accordingly
    const columnNumber = [anyYeasts, anyMalts, anyHops, anyKeyIngredients].filter(
        (item) => item !== null
    )?.length

    const containerClasses = classNames(
        'col-span-2 grid ingredients__container grid-cols-1 gap-8',
        columnNumber > 0 && columnNumber === 1
            ? 'grid-cols-1'
            : columnNumber === 2
            ? 'sm:grid-cols-2'
            : 'sm:grid-cols-2 lg:grid-cols-3'
    )

    return (
        <div className={containerClasses}>
            {anyYeasts && <Yeasts yeasts={anyYeasts} />}
            {anyMalts && <Malts malts={anyMalts} />}
            {anyHops && <Hops hops={anyHops} />}
            {anyKeyIngredients && <KeyIngredients />}
        </div>
    )
}

export default Ingredients
